var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"assistive-status",attrs:{"id":_vm.id,"tabindex":"0","aria-live":_vm.ariaLive},domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }